import store from '../store'

export default async function admin({ next, router }) {
  if (!store.getters.isAuthenticated) {
    return router.push({ name: 'Login' })
  }

  try {
    let profile = store.getters['profile/me']

    if (!profile) {
      await store.dispatch('profile/me')
      profile = store.getters['profile/me']
    }

    const roles = profile && Array.isArray(profile.roles) ? profile.roles : []
    const isAdmin = roles.some(role => {
      const name = typeof role === 'string' ? role : role && role.name
      return String(name || '').toLocaleLowerCase('fr') === 'admin'
    })

    if (!isAdmin) {
      return router.push({ path: '/dashboard' })
    }

    return next()
  } catch (error) {
    return router.push({ name: 'Login' })
  }
}
